



















































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { city } from '@/api/com'
import City from '@/components/City/index.vue'

@Component({
  name: 'SearchInput',
  components: {
    City
  }
})
export default class SearchInput extends Vue {
  /**
   * @param {Boolean} loading loading状态
   * @description: 默认true
   */
  @Prop({
    type: Boolean,
    default: false
  }) loading!: boolean

  /**
   * @param {Boolean} border 是否显示边框
   * @description: 默认true
   */
  @Prop({
    type: Boolean,
    default: true
  }) border!: boolean

  /**
   * @param {Boolean} radius 圆角角度
   * @description: 默认 10
   */
  @Prop({
    type: Number,
    default: 10
  }) radius!: number

  /**
   * @param {string,number} inputWidth 输入框宽度
   * @description: 默认220px
   */
  @Prop({
    type: [String, Number],
    default: '220px'
  }) inputWidth!: string | number

  /**
   * @param {string} inputCalssName 输入框class类名
   * @description: 输入框class类名
   */
  @Prop({
    type: String,
    default: ''
  }) inputCalssName!: string

  /**
   * @param {string} city 城市
   * @description: 是否开启城市-顶级城市（国家）分类
   */
  @Prop({
    type: Boolean,
    default: false
  }) city!: boolean

  /**
   * @param {string} cityPrefix 城市前缀
   * @description: 前缀文本
   */
  @Prop({
    type: String,
    default: ''
  }) cityPrefix!: string

  /**
   * @param {string} cityDefaultValue 默认选中的城市
   * @description: 默认选中的城市
   */
  @Prop({
    type: [String, Number],
    default: ''
  }) cityDefaultValue!: string | number

  /**
   * @param {string} type 类别
   * @description: 默认选中文本
   */
  @Prop({
    type: String,
    default: ''
  }) type!: string

  /**
   * @param {string} typePrefix 类别前缀
   * @description: 前缀文本
   */
  @Prop({
    type: String,
    default: ''
  }) typePrefix!: string

  /**
   * @param {Array} typeList 类别数据
   * @description:  如： 门票 套餐 等
   */
  @Prop({
    type: Array,
    default: () => ([])
  }) typeList!: any[]

  /**
   * @param {Number, String} typeDefaultValue 默认选中的类别
   * @description:
   */
  @Prop({
    type: [Number, String],
    default: ''
  }) typeDefaultValue!: number | string

  /**
   * @param {string} placeholder 占位提示文本
   * @description: 占位提示文本
   */
  @Prop({
    type: String,
    default: '请输入产品ID/关键字'
  }) placeholder!: string

  /**
   * @param {string} searchText 按钮文字
   * @description: 按钮文字
   */
  @Prop({
    type: String,
    default: '搜我的产品'
  }) searchText!: string

  /**
   * @param {string} value 输入框内容
   * @description: 输入框内容
   */
  @Prop({
    type: String,
    default: ''
  }) value!: string

  props = {
    lazy: true,
    lazyLoad: (node, resolve) => {
      const { level } = node
      console.log('level')
      console.log(level)
      const params = {
        parentId: node.value || 0
      }
      city(params)
        .then(res => {
          // if (level === 0) {
          //   console.log(res)
          //   this.cityValue.push(res[0].areaId)
          // }
          const nodes = res.map(item => {
            return {
              value: item.areaId,
              label: item.treeName,
              leaf: level >= 2
            }
          })
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(nodes)
        })
    }
  }

  // 城市列表选中的值
  // private cityValue: any[] = []
  private cityName = ''

  // 类型分类选中的值
  private typeValue: number | string = ''

  // 国家(城市)列表数据
  private cityList: any[] = []

  // 搜索框输入的值
  get keyword (): string {
    return this.value
  }

  set keyword (newData) {
    this.handleValue(newData)
  }

  @Emit('input')
  handleValue (newData) {
    return newData
  }

  get inputW (): string {
    if (typeof this.inputWidth === 'number') {
      return this.inputWidth + 'px'
    }
    return this.inputWidth
  }

  get radiuR (): string {
    if (typeof this.radius === 'number') {
      return this.radius + 'px'
    }
    return this.radius
  }

  // @Emit('change:city')
  // changeSelectCity (item: number[]): number {
  //   return item[item.length - 1]
  // }

  @Emit('change:type')
  changeSelect (item: number): number {
    return item
  }

  @Emit('search')
  inputSearch () {
    return this.keyword
  }

  // 切换城市
  @Emit('change:city')
  changeCity (item): number {
    console.log(item, 'item.........')
    this.cityName = item.areaName
    // this.activeCityInfo = item
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.popover.showPopper = false
    return item.areaId
  }

  clickSearch () {
    if (this.loading) return
    this.inputSearch()
  }

  mounted (): void {
    // if (this.city) {
    //   this.getCity()
    // }
    this.typeValue = this.typeDefaultValue
  }
}
